/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorOffIcon20Solid = forwardRef('TechScreenMonitorOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.046.455a1.125 1.125 0 0 0-1.591 1.59l1.638 1.639A2.994 2.994 0 0 0 2 6v6a3 3 0 0 0 3 3h3v1H6.75a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2H12v-1h2.409l2.795 2.796a1.125 1.125 0 0 0 1.591-1.591L3.046.454Z" }),
        React.createElement("path", { d: "M18 12c0 .269-.035.53-.102.777L8.121 3H15a3 3 0 0 1 3 3v6Z" })));
});
